/**
 * Idle-time route prefetcher.
 *
 * Replaces the static `<link rel="prefetch" href="/assets/Jobs.js">` hints
 * in index.html — those 404'd in production because Vite emits hashed
 * chunk names (`Jobs-XXX.js`) per build. Using dynamic `import()` lets
 * Vite resolve to the correct hashed URL at build time and warms the
 * browser's module cache, so the first navigation to /jobs or /auth
 * paints instantly instead of paying a cold round-trip.
 */
export function prefetchHotRoutes(): void {
  if (typeof window === "undefined") return;

  const warm = () => {
    // Hot routes — covers the vast majority of post-home navigations.
    void import("@/pages/Jobs");
    void import("@/pages/Auth");
    void import("@/pages/HowItWorks");
    void import("@/pages/Companies");
  };

  const w = window as Window & {
    requestIdleCallback?: (cb: IdleRequestCallback, opts?: { timeout: number }) => number;
  };

  if (typeof w.requestIdleCallback === "function") {
    w.requestIdleCallback(warm, { timeout: 4000 });
  } else {
    setTimeout(warm, 1500);
  }
}
